module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "m-l-50 m-t-30 w-1000",
    staticStyle: {
      "color": "#111"
    }
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules,
      "label-width": "120px"
    }
  }, [_c('div', {
    staticClass: "w-500 fl m-r-30"
  }, [_c('el-form-item', {
    attrs: {
      "label": ""
    }
  }, [_c('span', [_vm._v("企业基本信息")])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "企业简称",
      "prop": "company_name"
    }
  }, [_c('el-input', {
    staticClass: "h-40 w-300",
    attrs: {
      "clearable": "",
      "placeholder": "请输入企业名称"
    },
    model: {
      value: (_vm.form.company_name),
      callback: function($$v) {
        _vm.$set(_vm.form, "company_name", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "form.company_name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "企业联系人",
      "prop": "company_user"
    }
  }, [_c('el-input', {
    staticClass: "h-40 w-300",
    attrs: {
      "clearable": "",
      "placeholder": "请输入企业联系人"
    },
    model: {
      value: (_vm.form.company_user),
      callback: function($$v) {
        _vm.$set(_vm.form, "company_user", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "form.company_user"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "联系人职位",
      "prop": "company_position"
    }
  }, [_c('el-input', {
    staticClass: "h-40 w-300",
    attrs: {
      "clearable": "",
      "placeholder": "请输入联系人职位"
    },
    model: {
      value: (_vm.form.company_position),
      callback: function($$v) {
        _vm.$set(_vm.form, "company_position", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "form.company_position"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "企业电话",
      "prop": "company_phone"
    }
  }, [_c('el-input', {
    staticClass: "h-40 w-300",
    attrs: {
      "clearable": "",
      "placeholder": "请输入企业电话"
    },
    model: {
      value: (_vm.form.company_phone),
      callback: function($$v) {
        _vm.$set(_vm.form, "company_phone", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "form.company_phone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "企业邮箱",
      "prop": "company_email"
    }
  }, [_c('el-input', {
    staticClass: "h-40 w-300",
    attrs: {
      "clearable": "",
      "placeholder": "请输入企业邮箱"
    },
    model: {
      value: (_vm.form.company_email),
      callback: function($$v) {
        _vm.$set(_vm.form, "company_email", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "form.company_email"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "w-500",
    attrs: {
      "label": "纳税人性质",
      "prop": "vat_type"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.form.vat_type),
      callback: function($$v) {
        _vm.$set(_vm.form, "vat_type", $$v)
      },
      expression: "form.vat_type"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("小规模纳税人")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 2
    }
  }, [_vm._v("一般纳税人")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "单据二审",
      "prop": "company_2ex"
    }
  }, [_c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": 1
    },
    model: {
      value: (_vm.form.company_2ex),
      callback: function($$v) {
        _vm.$set(_vm.form, "company_2ex", $$v)
      },
      expression: "form.company_2ex"
    }
  }, [_vm._v("开启")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": 0
    },
    model: {
      value: (_vm.form.company_2ex),
      callback: function($$v) {
        _vm.$set(_vm.form, "company_2ex", $$v)
      },
      expression: "form.company_2ex"
    }
  }, [_vm._v("关闭")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "出纳角色",
      "prop": "company_cashier"
    }
  }, [_c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": 1
    },
    model: {
      value: (_vm.form.company_cashier),
      callback: function($$v) {
        _vm.$set(_vm.form, "company_cashier", $$v)
      },
      expression: "form.company_cashier"
    }
  }, [_vm._v("开启")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": 0
    },
    model: {
      value: (_vm.form.company_cashier),
      callback: function($$v) {
        _vm.$set(_vm.form, "company_cashier", $$v)
      },
      expression: "form.company_cashier"
    }
  }, [_vm._v("关闭")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "w-400 fl"
  }, [_c('el-form-item', {
    attrs: {
      "label": ""
    }
  }, [_c('span', [_vm._v("企业注册信息")])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "企业全称",
      "prop": "rise_company_name"
    }
  }, [_c('el-input', {
    staticClass: "h-40 w-300",
    attrs: {
      "placeholder": "请输入企业全称",
      "clearable": ""
    },
    model: {
      value: (_vm.form.rise_company_name),
      callback: function($$v) {
        _vm.$set(_vm.form, "rise_company_name", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "form.rise_company_name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "纳税人识别号",
      "prop": "rise_discern_code"
    }
  }, [_c('el-input', {
    staticClass: "h-40 w-300",
    attrs: {
      "placeholder": "请输入纳税人识别号",
      "clearable": ""
    },
    model: {
      value: (_vm.form.rise_discern_code),
      callback: function($$v) {
        _vm.$set(_vm.form, "rise_discern_code", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "form.rise_discern_code"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "企业注册地址",
      "prop": "rise_company_addr"
    }
  }, [_c('el-input', {
    staticClass: "h-40 w-300",
    attrs: {
      "placeholder": "请输入企业注册地址",
      "clearable": ""
    },
    model: {
      value: (_vm.form.rise_company_addr),
      callback: function($$v) {
        _vm.$set(_vm.form, "rise_company_addr", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "form.rise_company_addr"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "企业联系电话",
      "prop": "rise_company_phone"
    }
  }, [_c('el-input', {
    staticClass: "h-40 w-300",
    attrs: {
      "placeholder": "请输入企业联系电话",
      "clearable": ""
    },
    on: {
      "change": function($event) {
        return _vm.set_phone()
      }
    },
    model: {
      value: (_vm.form.rise_company_phone),
      callback: function($$v) {
        _vm.$set(_vm.form, "rise_company_phone", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "form.rise_company_phone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "开户行名称",
      "prop": "rise_bank_name"
    }
  }, [_c('el-input', {
    staticClass: "h-40 w-300",
    attrs: {
      "placeholder": "请输入开户行名称",
      "clearable": ""
    },
    model: {
      value: (_vm.form.rise_bank_name),
      callback: function($$v) {
        _vm.$set(_vm.form, "rise_bank_name", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "form.rise_bank_name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "开户银行账号",
      "prop": "rise_bank_code"
    }
  }, [_c('el-input', {
    staticClass: "h-40 w-300",
    attrs: {
      "placeholder": "请输入开户银行账号",
      "clearable": ""
    },
    model: {
      value: (_vm.form.rise_bank_code),
      callback: function($$v) {
        _vm.$set(_vm.form, "rise_bank_code", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "form.rise_bank_code"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "w-900",
    staticStyle: {
      "overflow": "hidden"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "允许使用模块"
    }
  }, [_c('el-checkbox-group', {
    model: {
      value: (_vm.form.mokuai),
      callback: function($$v) {
        _vm.$set(_vm.form, "mokuai", $$v)
      },
      expression: "form.mokuai"
    }
  }, _vm._l((_vm.mokuai), function(item) {
    return _c('el-checkbox', {
      attrs: {
        "label": item.id
      }
    }, [_vm._v(_vm._s(item.menu_name))])
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small",
      "loading": _vm.isLoading
    },
    on: {
      "click": function($event) {
        return _vm.add()
      }
    }
  }, [_vm._v("保 存")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.goback()
      }
    }
  }, [_vm._v("返 回")])], 1)], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-ce1655e2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Appistrative/company/company/edit.vue
// module id = 1875
// module chunks = 2